<template>
  <div class="v-date-range">
    <v-menu offset-y close-on-content-click close-on-click>
      <template v-slot:activator="{ on }">
        <v-btn color="grey lighten-2" depressed v-on="on" v-html="thresholdText">
          <v-icon right>arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item style="width: 200px"
                     v-for="(preset, presetIndex) in presets"
                     :key="`threshold-${presetIndex}`"
                     @click="changeThreshold(presetIndex)">
          <v-list-item-content>
            <v-list-item-title :class="{'primary--text': presetIndex === threshold}">{{ preset.text }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="presetIndex === threshold">
            <v-icon class="primary--text">check</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog ref="customDialog"
              v-model="customDialog"
              width="653px"
              @keydown.esc="thresholdDialog = false">
      <v-card flat>
        <v-card-text class="pb-0">Custom</v-card-text>
        <v-card-title class="py-0 title"><strong>{{ customThreshold.from.format(humanDateFormat) }} &mdash; {{ customThreshold.to.format(humanDateFormat) }}</strong></v-card-title>
        <v-card-text>
          <v-date-picker class="mr-4 v-date-range__picker--start v-date-range__picker"
                        :no-title="true"
                        :value="customThreshold.from.format('YYYY-MM-DD')"
                        @input="changeCustomThreshold('from', $event)"
                        :max="customThreshold.to.format('YYYY-MM-DD')"
                        reactive></v-date-picker>
          <v-date-picker class="v-date-range__picker--end v-date-range__picker"
                        :no-title="true"
                        :value="customThreshold.to.format('YYYY-MM-DD')"
                        @input="changeCustomThreshold('to', $event)"
                        :min="customThreshold.from.format('YYYY-MM-DD')"
                        :max="presets.find(preset => preset.text === 'Today').to.format('YYYY-MM-DD')"
                        reactive></v-date-picker>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="customDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="applyCustomThreshold">Apply</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { thresholds } from './date-range.helpers'

export default {
  name: 'DateRange',
  props: {
    value: {
      type: Object
    },
    options: {
      type: Array,
      default () {
        return [
          'Today',
          'Yesterday',
          'Custom...'
        ]
      }
    },
    defaultOption: {
      type: String,
      default () {
        return this.options[0]
      }
    }
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      humanDateFormat: 'MMMM D, YYYY',
      presets: [],
      threshold: -1,
      customDialog: false
    }
  },
  watch: {
    options: {
      deep: true,
      immediate: true,
      handler: function (presets, oldVal) {
        for (const preset in presets) {
          if (presets.hasOwnProperty(preset)) {
            this.presets.push(thresholds.find(threshold => threshold.text === presets[preset]))
          }
        }
      }
    },
    threshold: {
      immediate: true,
      handler () {
        if (this.threshold < 0) {
          this.threshold = this.presets.indexOf(this.presets.find(preset => preset.text === this.defaultOption))
        }
        this.$emit('input', this.presets[this.threshold])
      }
    }
  },
  computed: {
    thresholdText () {
      return this.threshold !== this.presets.indexOf(this.customThreshold)
        ? this.presets[this.threshold].text
        : this.thresholdRange
    },
    thresholdRange () {
      return `${this.presets[this.threshold].from.format(this.humanDateFormat)} &mdash; ${this.presets[this.threshold].to.format(this.humanDateFormat)}`
    },
    customThreshold () {
      return this.presets.find(preset => preset.text === 'Custom...')
    }
  },
  methods: {
    changeThreshold (presetIndex) {
      if (this.presets.indexOf(this.customThreshold) !== presetIndex) {
        this.threshold = presetIndex
      } else {
        this.customThreshold.from = this.presets[this.threshold].from
        this.customThreshold.to = this.presets[this.threshold].to
        this.customDialog = true
      }
    },
    changeCustomThreshold (type, value) {
      this.customThreshold[type] = moment(value, this.dateFormat)
    },
    applyCustomThreshold () {
      const preset = this.presets.find(preset => preset.from.format(this.dateFormat) === this.customThreshold.from.format(this.dateFormat) && preset.to.format(this.dateFormat) === this.customThreshold.to.format(this.dateFormat))
      if (preset) {
        this.threshold = this.presets.indexOf(preset)
      } else {
        this.threshold = this.presets.indexOf(this.customThreshold)
      }
      this.customDialog = false
    }
  }
}
</script>
